module.exports = __webpack_public_path__ + "img/PSA.4c1c5015.jpg";